import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./Section.scss');

export interface SectionProps {
    title: string;
    children?: React.ReactNode;
}

const Section = (props: SectionProps) => {
    return (
        <div className={styles.detailsSection}>
            <span className={styles.detailsSectionHeader}>{props.title}</span>
            <hr className={styles.divider} />
            {props.children}
        </div>
    );
};

export default observer(Section);
